export default __webpack_public_path__ + "images/close_71fc38.svg";